<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Produkte aus altem Export kopieren
            </FarmTitle>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-8">
                    <h1 class="text-2xl">Produkte, welche <strong>nicht</strong> kopiert werden sollen</h1>
                        <div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-4">
                            <div class="relative flex items-start" v-for="product in products">
                                <div class="flex items-center h-5">
                                    <input :id="'product-'+product.id" v-model="form.excluded_products" :value="product.id" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                </div>
                                <div class="ml-3 text-sm">
                                    <label :for="'product-'+product.id" class="font-medium text-gray-900">{{ product.name }} ({{ product.item_number }})</label>
                                </div>
                            </div>
                        </div>
                    <input type="date" v-model="form.date" />
                    {{ form.excluded_products }}
                    <button @click="form.post(route('product.copy', export_id))" type="button" class="mt-4 float-right inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Aus altem Export kopieren
                    </button>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import FarmTitle from "@/Layouts/FarmTitle";
    import Button from "@/Jetstream/Button";
    import HorseEdit from "@/Modules/HorseEdit";
    import AppLayout from "@/Layouts/AppLayout";
    import {ExclamationIcon, InformationCircleIcon, PlusIcon} from "@heroicons/vue/solid/esm";
    import JetInputError from "@/Jetstream/InputError";
    import JetDialogModal from "@/Jetstream/DialogModal";

    export default {
        components: {FarmTitle, Button, HorseEdit, AppLayout, ExclamationIcon, InformationCircleIcon, PlusIcon, JetInputError, JetDialogModal },
        name: "CopyFromExport",
        props: ['export_id', 'products', 'farm'],
        data() {
            return {
                form: new this.$inertia.form({
                    date: new Date().toISOString().split('T')[0],
                    excluded_products: []
                })
            }
        }
    }
</script>

<style scoped>

</style>
